import { useEffect, useRef } from "react";
import Highcharts from "highcharts";
import bellcurve from "highcharts/modules/histogram-bellcurve";
import { Empty } from "antd";

bellcurve(Highcharts);

const BellCurveChart = ({
  options,
  height = "400px",
  onChartCreated,
}: {
  options: Highcharts.Options | null;
  height?: string;
  onChartCreated?: (chart: Highcharts.Chart) => void;
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const chartRef = useRef<Highcharts.Chart | null>(null);
  const onChartCreatedRef = useRef(onChartCreated);
  onChartCreatedRef.current = onChartCreated;

  useEffect(() => {
    if (chartRef.current) {
      try {
        chartRef.current.destroy();
      } catch {
        // ignore destroy errors on unmount
      }
      chartRef.current = null;
    }
    if (containerRef.current && options?.series) {
      chartRef.current = Highcharts.chart(containerRef.current, {
        ...options,
        chart: { ...options.chart, height },
      });
      setTimeout(() => {
        if (chartRef.current && onChartCreatedRef.current) {
          onChartCreatedRef.current(chartRef.current);
        }
      }, 100);
    }
  }, [options, height]);

  if (!options?.series) {
    return <Empty description="No data in the specified date range" />;
  }

  return <div ref={containerRef} style={{ width: "100%", height }} />;
};

export default BellCurveChart;
